export const DEFAULT_COLORS = [
  'rgb(38,142,80)',
  'rgb(41,77,100)',
  'rgb(147,214,61)',
];
// export const DEFAULT_COLORS = ['#00923f', '#ED7363', '#00FFFF'];
